export enum StatusHTTPS {
  Ok = 200,
  StatusNonAuthoritativeInfo = 203,
  InternalServerError = 500,
}
